import { useCallback } from 'react';
import { setTypeText } from '@platform/features/workspaces/builder';
import { overrideApi } from '@platform/state/api';
import { useAppDispatch, useAppSelector } from '@platform/state/hooks';
import { selectLang } from '@platform/state/selectors';

/**
 * Перейменування типу запису в просторі зі сторінки «Встановлені модулі» (ADR-023 `name` мовою інтерфейсу): поточне перевизначення
 * читається (з кешу, якщо є), назва зливається з ним і зберігається з If-Match його версії. Збіг з опублікованою назвою прибирає перевизначення.
 */
export function useRenameRecordType(ws: string): (module: string, rt: string, name: string, published: string) => Promise<unknown> {
  const dispatch = useAppDispatch();
  const lang = useAppSelector(selectLang);
  return useCallback(async (module, rt, name, published) => {
    const doc = await dispatch(overrideApi.endpoints.recordTypeOverride.initiate({ ws, rt })).unwrap();
    const patch = setTypeText(doc.patch, 'name', lang, name, published);
    return dispatch(overrideApi.endpoints.saveRecordTypeOverride.initiate({ ws, rt, module, patch, version: doc.version })).unwrap();
  }, [dispatch, lang, ws]);
}
